<template>
  <div class="admin">
    <v-toolbar color="primary" dark dense class="admin__toolbar mb-3">
      <v-toolbar-title>{{pageTitle}}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-items v-if="$vuetify.breakpoint.width > 1199">
        <v-btn flat to="/admin/" exact>Team</v-btn>
        <!-- <v-btn flat to="/admin/customers">Customers</v-btn> -->
        <v-btn flat to="/admin/users">Users</v-btn>
        <v-btn flat to="/admin/roles">Roles</v-btn>
        <v-btn flat to="/admin/products">Products</v-btn>
        <v-btn flat to="/admin/attributes">Attributes</v-btn>
        <v-btn flat to="/admin/alerts">Alerts</v-btn>
        <!-- <v-btn flat to="/admin/documents">Document Center</v-btn> -->
        <v-btn flat to="/admin/categories">Document Center</v-btn>
      </v-toolbar-items>

      <v-menu bottom left offset-x open-on-hover v-else>
        <v-btn small slot="activator" icon>
          <div class="v-icon">
            <fa-icon :icon="['far', 'ellipsis-v']" size="sm" />
          </div>
        </v-btn>

        <v-list class="pa-0">
          <v-list-tile to="/admin/" exact>
            <v-list-tile-title>Team</v-list-tile-title>
          </v-list-tile>
          <!-- <v-list-tile to="/admin/customers">
								<v-list-tile-title>Customers<</v-list-tile-title>
          </v-list-tile>-->
          <v-list-tile to="/admin/users">
            <v-list-tile-title>Users</v-list-tile-title>
          </v-list-tile>
          <v-list-tile to="/admin/roles">
            <v-list-tile-title>Roles</v-list-tile-title>
          </v-list-tile>
          <v-list-tile to="/admin/products">
            <v-list-tile-title>Products</v-list-tile-title>
          </v-list-tile>
          <v-list-tile to="/admin/attributes">
            <v-list-tile-title>Attributes</v-list-tile-title>
          </v-list-tile>
          <v-list-tile to="/admin/alerts">
            <v-list-tile-title>Alerts</v-list-tile-title>
          </v-list-tile>
          <!-- <v-list-tile to="/admin/document-center">
            <v-list-tile-title>Document Center</v-list-tile-title>
          </v-list-tile>-->

          <v-list-tile to="/admin/categories">
            <v-list-tile-title>Document Center</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-fade-transition mode="out-in" appear>
      <router-view class="admin__route"></router-view>
    </v-fade-transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    pageTitle() {
      return this.getMetaValue("title");
    }
  },

  methods: {
    getMetaValue(key) {
      let matched = this.getObjectValue("matched", this.$route);

      for (let i = 1; i < matched.length; i++) {
        let value = this.getObjectValue(`meta.${key}`, matched[i]);
        if (value !== null) {
          return value;
        }
      }
      return null;
    }
  }
};
</script>
